import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@cdk-uip/icons";
import "@cdk-uip/react/cdk.css";
import "typeface-roboto";
import OnePayApp from "./OnePayApp";

ReactDOM.render(<OnePayApp />, document.getElementById("root"));
